package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import org.gstechnovos.jexonplastech.models.Achievement
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.util.Constants
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun AchievementCard (
    modifier: Modifier = Modifier,
    animatedNumber: Int,
    achievement: Achievement
){

    Row (modifier = modifier,
        verticalAlignment = Alignment.CenterVertically){

        Image(src = achievement.icon,
            modifier = Modifier.size(70.px).margin(20.px), description = achievement.description)

        Column {

            P(
                attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY).fontSize(30.px).fontWeight(
                        FontWeight.Bolder
                    ).color(Theme.Primary.rgb).toAttrs()
            ) {
                Text(if (achievement == Achievement.Completed)
                    "${animatedNumber}+" else "${animatedNumber}")
            }

            P(
                attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY).fontSize(16.px).fontWeight(
                        FontWeight.Normal
                    ).color(Theme.Secondary.rgb).opacity(50.percent).toAttrs()
            ) {
                Text(achievement.description)
            }
        }
    }
}